import { FC } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { useHoteleria } from '../../../../../../hooks/useHoteleria'
import { TabModel } from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import { FormGuest } from '../Forms/FormGuest'
import { TableGuestBookingWrapper } from '../Tables/TableGuestBooking'
import { TableRelevosWrapper } from '../Tables/TableRelevos'

const GuestDetailWrapper: FC = () => {
  const { currentTabItem, changeCurrentTabItem, isAllowed } = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
            {isAllowed('RESERVASXHUESPED/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Reservas por Huésped</Tab>
            )}
            {isAllowed('RESERVASXHUESPED/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Relevos</Tab>
            )}
          </TabList>
          <TabPanel>
            <FormGuest />
          </TabPanel>
          {isAllowed('RESERVASXHUESPED/ACCESO') && (
            <TabPanel>
              <TableGuestBookingWrapper />
            </TabPanel>
          )}
          {isAllowed('RESERVASXHUESPED/ACCESO') && (
            <TabPanel>
              <TableRelevosWrapper />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  )
}

export { GuestDetailWrapper }
